export default __webpack_public_path__ + "be40ff29941abb61e73c729c2af7c976.png";